import { heroData } from '@/mocks/homeData';

export default function Hero() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative pt-[72px] min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 xl:gap-16 max-w-7xl mx-auto">
          <div className="w-full lg:w-1/2 flex flex-col gap-5">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-accent-100 text-accent-700 text-sm font-medium rounded-full w-fit">
              <i className="ri-fire-line"></i>
              {heroData.tag}
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              {heroData.h1}
            </h1>

            <p className="text-lg md:text-xl text-accent-600 font-heading font-medium">
              {heroData.slogan}
            </p>

            <div className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl">
              {heroData.intro.split('。').filter(Boolean).map((sentence, i) => (
                <span key={i}>
                  {sentence}。
                  {i % 3 === 2 && i < heroData.intro.split('。').filter(Boolean).length - 1 && (
                    <>
                      <br /><br />
                    </>
                  )}
                </span>
              ))}
            </div>

            <div className="flex flex-wrap gap-4 md:gap-6">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="flex flex-col">
                  <span className="text-xl md:text-2xl font-heading font-bold text-accent-600">{stat.value}</span>
                  <span className="text-xs md:text-sm text-foreground-500">{stat.label}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-3 pt-2">
              <button
                onClick={() => handleClick(heroData.ctaPrimary.href)}
                className="px-8 py-3 bg-accent-500 text-white font-medium rounded-full hover:bg-accent-600 transition-colors text-sm md:text-base whitespace-nowrap cursor-pointer"
              >
                {heroData.ctaPrimary.text}
              </button>
              <button
                onClick={() => handleClick(heroData.ctaSecondary.href)}
                className="px-8 py-3 border-2 border-accent-300 text-accent-700 font-medium rounded-full hover:bg-accent-50 transition-colors text-sm md:text-base whitespace-nowrap cursor-pointer"
              >
                {heroData.ctaSecondary.text}
              </button>
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <div className="relative w-full aspect-[4/3] md:aspect-[16/10] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20entertainment%20news%20and%20celebrity%20scandal%20concept%2C%20dramatic%20red%20and%20cream%20composition%20with%20newspaper%20textures%20and%20spotlights%2C%20modern%20clean%20aesthetic%2C%20mysterious%20atmosphere%2C%20soft%20gradient%20lighting%2C%20artistic%20cinematic%20style&width=1200&height=800&seq=hero-main-visual&orientation=landscape"
                alt="吃瓜网每日大赛 - 娱乐圈争议事件深度起底"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-accent-900/15 via-transparent to-accent-900/10 pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}